import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Package, Pencil, Check } from 'lucide-react';
import { API_URL, fmtDT } from './lmShared';

const BatchRow = ({ b, onSaved, onOpen }) => {
  const [edit, setEdit] = useState(false);
  const [name, setName] = useState(b.name || '');
  const [custo, setCusto] = useState(b.custo ?? '');
  const pct = b.total ? Math.round((100 * b.trabalhadas) / b.total) : 0;

  const save = async () => {
    try {
      await axios.put(`${API_URL}/lead-mgmt/batches/${encodeURIComponent(b.batch_id)}`, { name, custo: custo === '' ? null : String(custo).replace(',', '.') });
      setEdit(false);
      onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erro'); }
  };

  return (
    <div className="py-3 border-b border-slate-100 last:border-0" data-testid={`lm-batch-${b.batch_id}`}>
      {edit ? (
        <div className="space-y-1.5">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome do lote (ex.: Listagem Outubro)" className="w-full border rounded px-2 py-1 text-xs" data-testid="lm-batch-name-input" />
          <div className="flex gap-1.5">
            <input value={custo} onChange={(e) => setCusto(e.target.value)} placeholder="Custo do lote (€)" inputMode="decimal" className="flex-1 border rounded px-2 py-1 text-xs" data-testid="lm-batch-cost-input" />
            <button type="button" onClick={save} className="px-2 rounded bg-[#2D3E6F] text-white" data-testid="lm-batch-save"><Check className="w-3.5 h-3.5" /></button>
          </div>
        </div>
      ) : (
        <div className="flex items-start gap-2">
          <button type="button" onClick={() => onOpen(b)} className="flex-1 text-left" data-testid={`lm-batch-open-${b.batch_id}`}>
            <p className="text-sm font-medium text-slate-800">{b.name || `Importação ${fmtDT(b.batch_id)}`}</p>
            <p className="text-[11px] text-slate-500">{b.total} leads · {pct}% trabalhadas · {b.convertidas} convertidas · {b.fechadas_sem_contrato} sem contrato{b.por_atribuir ? ` · ${b.por_atribuir} por atribuir` : ''}</p>
            {b.custo != null && (
              <p className="text-[11px] text-emerald-700 font-semibold">Custo {Number(b.custo).toFixed(2)} € · {b.custo_por_contrato != null ? `${b.custo_por_contrato.toFixed(2)} € por contrato` : 'sem contratos ainda'}</p>
            )}
            <div className="h-1.5 bg-slate-100 rounded-full mt-1 overflow-hidden"><div className="h-full bg-sky-500" style={{ width: `${pct}%` }} /></div>
          </button>
          <button type="button" onClick={() => setEdit(true)} className="p-1 text-slate-400 hover:text-[#2D3E6F]" title="Nome e custo" data-testid={`lm-batch-edit-${b.batch_id}`}><Pencil className="w-3.5 h-3.5" /></button>
        </div>
      )}
    </div>
  );
};

export const LmBatchesCard = ({ batches, onSaved, onOpen }) => (
  <div className="bg-white rounded-2xl border border-slate-200 p-4" data-testid="lm-batches-card">
    <h3 className="text-sm font-bold text-slate-800 flex items-center gap-2 mb-1"><Package className="w-4 h-4 text-[#2D3E6F]" /> Lotes importados</h3>
    <p className="text-[11px] text-slate-400 mb-1">Clique num lote para ver e reatribuir as leads. O lápis permite dar nome e custo.</p>
    {batches.length === 0 && <p className="text-xs text-slate-400 py-4">Sem importações neste filtro.</p>}
    {batches.map((b) => <BatchRow key={b.batch_id} b={b} onSaved={onSaved} onOpen={onOpen} />)}
  </div>
);
